const navTrad = {
    fr: {
        titre: "Mes Projets",
        games: "Jeux",
        code: "Projet de code",
        pro:  "Projets profesionnels",
        bouton: "TELECHARGER CV",
    },
    en: {
        titre: "My Projects",
        games: "Games",
        code: "Programming",
        pro:  "Professional projects",
        bouton: "DOWNLOAD CV",
    },
};

export default navTrad;
